import { Navigate } from "react-router-dom";
import { useAuth } from "@contexts/AuthContext";
import { PermissionDenied } from "./ui/PermissionDenied";

const ProtectedRoute = ({ children, permission }) => {
  const { user, isAdmin, isLoading, hasPermission } = useAuth();

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-gray-500">Loading...</div>
      </div>
    );
  }

  // Not logged in -> Redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Logged in but not admin -> Show Access Denied
  if (!isAdmin) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Access Denied
          </h2>
          <p className="text-gray-600">
            Admin privileges required to access this page.
          </p>
        </div>
      </div>
    );
  }

  // Check specific permission if provided
  if (permission && !hasPermission(permission)) {
    return <PermissionDenied requiredPermission={permission} />;
  }

  // User is authenticated and is admin
  return children;
};

export default ProtectedRoute;
